import React from 'react';
import { Field } from 'redux-form';

import { TextField, SelectField } from 'redux-form-material-ui';

import { MdDelete as DeleteIcon } from 'react-icons/md';
import { MdChevronRight as ChevronRightIcon } from 'react-icons/md';
import IconButton from 'material-ui/IconButton';
import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';

import { CSSTransitionGroup } from 'react-transition-group';
import { AccentColor } from 'helpers/AccentColorHelper';
import * as validator from 'helpers/Validator';

import { roomTypes } from '../SavedRooms';

class InternalRooms extends React.Component {
  render() {
    const { fields, changeNode } = this.props;

    const style = {
      internal_room_field: {
        marginTop: '-15px',
        fontSize: '14px',
        textAlign: 'left',
        width: '100%',
      },
      internal_room_icon: {
        padding: 0,
        verticalAlign: 'text-bottom',
        width: 'none',
        height: 'none',
        float: 'right',
        marginTop: '10px',
      },
    };

    return (
      <div>
        <CSSTransitionGroup
          transitionName="add_room"
          transitionEnterTimeout={300}
          transitionLeaveTimeout={300}
        >
          {fields.map((internalRoom, index) => (
            <div key={`internal_room_${index}`}>
              <div className="row" style={{ marginBottom: '25px' }}>
                <div className="col-xs-5">
                  <Field
                    name={`${internalRoom}.room_type`}
                    validate={[validator.required]}
                    component={SelectField}
                    floatingLabelText="Room Type"
                    style={style.internal_room_field}
                  >
                    {roomTypes.map((room) => {
                      return (
                        <MenuItem
                          key={`internal_room_${index}_${room.value}`}
                          value={room.value}
                          primaryText={room.primaryText}
                        />
                      );
                    })}
                  </Field>
                </div>
                <div className="col-sm-5" style={{ textAlign: 'center' }}>
                  <Field
                    name={`${internalRoom}.name`}
                    type="text"
                    component={TextField}
                    validate={[validator.required]}
                    floatingLabelText="Name"
                    style={style.internal_room_field}
                  />
                </div>
                <div className="col-sm-1" style={{ textAlign: 'center' }}>
                  <IconButton style={style.internal_room_icon} onClick={() => fields.remove(index)}>
                    <DeleteIcon size={24} style={{ padding: 0 }} />
                  </IconButton>
                </div>
                <div className="col-sm-1" style={{ textAlign: 'center' }}>
                  <IconButton
                    style={style.internal_room_icon}
                    onClick={() => changeNode(`${internalRoom}`)}
                  >
                    <ChevronRightIcon size={24} />
                  </IconButton>
                </div>
              </div>
            </div>
          ))}

          <div className="row" style={{ textAlign: 'center', marginTop: '20px' }}>
            <FlatButton
              label="Add Internal Room"
              type="button"
              backgroundColor={AccentColor()}
              hoverColor="grey"
              style={{ color: 'white' }}
              onClick={() => fields.push({})}
            />
          </div>
        </CSSTransitionGroup>
      </div>
    );
  }
}

export default InternalRooms;
